import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DateHelperService } from '../../../services/date-helper.service';

import { getIconURL, formatSizeUnits, setDOMSanitizer, setSafeResourceUrlService } from '../common/functions';
import { SafeResourceUrlService } from '../../../services/safe-resource-url.service';
import { FileTypeService } from '../../../services/file-type.service';

@Component({
  selector: 'hr-grid-subcmp',
  templateUrl: './file-grid.component.html',
  styleUrl: './file-grid.component.scss',
  standalone: false,
})
export class HRGridFile implements OnInit, OnChanges {
  @Input() file: any;
  @Input() tightDateMargin: boolean = false;
  @Input() compactView: boolean = false;
  @Input() hideDeleteButton: boolean = false;
  @Input() subSectionId: any;
  @Input() forTranscript: boolean = false;
  @Input() uploading: boolean = false;
  @Input() projectId: string;
  @Input() canEditFilename: boolean = false;
  @Output() nameClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() iconClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteCallback: EventEmitter<any> = new EventEmitter<any>();

  isAudioFile: boolean;

  constructor(
    private readonly sane: DomSanitizer,
    private readonly fileTypeService: FileTypeService,
    private readonly dateHelperService: DateHelperService,
    private readonly safeResourceUrlService: SafeResourceUrlService
  ) {
    setDOMSanitizer(this.sane);
    setSafeResourceUrlService(this.safeResourceUrlService);
  }

  ngOnInit() {
    this.isAudioFile = this.fileTypeService.isAudioFile(this.file) || this.fileTypeService.isVideoFile(this.file);
    this.file.displayTime = this.dateHelperService.fromTimestampToDate(this.file.timeCreated);
    if (!this.file.id) {
      this.file.displaySize = this.formatSizeUnits(this.file.size);
      this.file.displayName = this.truncate(this.file.displayName || this.file.fileProperties.fileName);
    }
  }

  ngOnChanges(changes) {
    if (!this.file.id) this.file.contentType = this.file.type;
    this.file.printName =
      this.file.displayName || this.file.name || this.file.title || this.file.fileProperties.fileName;
    this.file.typeIcon = getIconURL(this.file);
    this.file.displaySize = formatSizeUnits(this.file.size);
    this.file.displayTime = this.dateHelperService.fromTimestampToDate(this.file.timeCreated);
  }

  handleNameClick() {
    if (this.canEditFilename) {
      return;
    }
    this.nameClick.emit(this.file);
  }

  handleIconClick() {
    this.iconClick.emit(this.file);
  }

  deleteFile() {
    this.deleteCallback.emit(this.file);
  }

  private formatSizeUnits(bytes) {
    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + ' GB';
    } else if (bytes >= 1048576) {
      bytes = (bytes / 1048576).toFixed(2) + ' MB';
    } else if (bytes >= 1024) {
      bytes = (bytes / 1024).toFixed(2) + ' KB';
    } else if (bytes > 1) {
      bytes = bytes + ' bytes';
    } else if (bytes == 1) {
      bytes = bytes + ' byte';
    } else {
      bytes = '0 byte';
    }
    return bytes;
  }
  private truncate(fileName) {
    if (fileName?.length > 20)
      return fileName.substring(0, 20) + '...' + fileName.substring(fileName.length - 4, fileName.length);
    return fileName;
  }
}
